<template>
  <section class="evento-lux">
    <!-- ===== TARJETA: RECEPCIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      <img class="icono" src="@/assets/10.avif" alt="" />
      <h3 class="titulo-script">Celebración</h3>
      <p class="lugar">CROWN JEWEL BALLROOM</p>

      <p class="lugar2"><br>
1326 Callaghan Rd, San Antonio, Texas.    </p>

      <!-- Foto circular debajo del nombre del lugar -->
   

      <p class="direccion">
      </p>
            <p class="hora">5:00 PM</p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/b7fuzT58QKsNsFEP9"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen" aria-hidden="true"></span>
      </a>
    </article>
  </section>

  <!-- Escena final: degradado + torre -->
  <div class="lux-escena-final" aria-hidden="true">
    <div class="lux-degradado"></div>
    <img
      class="lux-flores"
      src="@/assets/moñii.png"
      alt=""
      loading="lazy"
      decoding="async"
    />
  </div>
</template>


<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card2 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {
      const $ = gsap.utils.selector(cardEl)
      
      // Timeline con ScrollTrigger para ejecución consecutiva
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 88%',
          end: 'bottom 65%',
          scrub: 0.25
        },
        defaults: { ease: 'power2.out', duration: 0.4 }
      })

      // Secuencia consecutiva: uno tras otro
      tl.from(cardEl, {
        opacity: 0,
        y: 30,
        filter: 'blur(5px)'
      })
      .from($('.icono'), {
        opacity: 0,
        y: 20,
        scale: 0.8
      })
      .from($('.titulo-script'), {
        opacity: 0,
        y: 20
      })
      .from($('.lugar'), {
        opacity: 0,
        x: -20
      })
      .from($('.lugar2'), {
        opacity: 0,
        x: 20
      })
      .from($('.hora'), {
        opacity: 0,
        scale: 0.9
      })
      .from(btnEl, {
        opacity: 0,
        y: 15,
        scale: 0.95
      })

      // Disparo único del brillo al entrar en pantalla
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 88%',
        once: true,
        onEnter: () => {
          const shine = btnEl?.querySelector('.sheen')
          if (shine) {
            gsap.fromTo(
              shine,
              { xPercent: -110, opacity: 0 },
              { xPercent: 140, opacity: 1, duration: 0.8, ease: 'power2.inOut' }
            )
          }
        }
      })
    }

    onMounted(() => {
      if (card2.value && btn2.value) {
        animCard(card2.value, btn2.value)
      }
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root {
  --rosa: #c6dff4;
  --rosa-alt: #c3def0;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux {
  min-height: 100%;
  padding: 28px 18px 64px;
    background:#f3f7fd;

  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card {
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;  background:#f3f7fd;

  padding: 24px 20px 28px;
  text-align: center;
}

/* Icono discreto */
.icono {
  width: 52px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.05));
  opacity: 0.92;
}

/* Imagen circular pequeña del lugar */
.imagen-lugar-wrapper {
  width: 250px;
  height: 250px;
  margin: 10px auto 14px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.15);
}

.imagen-lugar {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* Tipos (usa tus fuentes ya cargadas) */
.titulo-script {
  font-family: 'titulos', cursive;
  font-weight: 400;
  font-size: 66px;
  color: var(--tinta);
  letter-spacing: 0.4px;
  margin: 4px 0 8px;
}
.hora {
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}
.lugar2 {
  font-family: 'padres', serif;
  font-size: 20px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: 0.14em;
}
.lugar {
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 600;
  margin: 0 0 10px;
  letter-spacing: 0.14em;
}
.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: rgb(36, 74, 156);
  color: #ffffff;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 16px;
  line-height: 1;
  box-shadow:
    0 8px 16px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    filter 0.16s ease;
  border: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 0;
}
.btn-rosa:hover {
  transform: translateY(-1px);
  box-shadow:
    0 12px 20px rgba(0, 0, 0, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  filter: brightness(1.03);
}
.btn-rosa .sheen {
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  transform: rotate(20deg);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
  mix-blend-mode: screen;
  opacity: 0;
}

/* ==================== LÍNEA VERTICAL (si luego la usas) ==================== */
.linea-wrapper {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 12px;
}
.linea {
  width: 1px;
  height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script {
    font-size: 32px;
  }
  .hora {
    font-size: 22px;
  }
  .lugar {
    font-size: 16px;
  }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}

/* ===== Escena final (degradado + torre) ===== */
.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;
  margin-bottom: -30px;
  overflow: visible;
}

.lux-degradado {
  width: 100%;
  height: 180px;
  background: linear-gradient(
    to top,
    #b3bfcc 0%,
    rgba(213, 232, 246, 0.85) 35%,
    rgba(246, 213, 229, 0.35) 65%,
    rgba(246, 213, 229, 0) 100%
  );
}

.lux-flores {
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  width: min(460px, 40%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.08));
  opacity: 0.98;
}
</style>